import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      {!data.isLoading && (
        <button
          className={`btn-wrapper ${data.layerStyles} ${data.style} ${data.buttonType} ${data.disable} ${data.buttonSize} ${data.option}`}
          type={data.type}
          disable={data.disable}
          onClick={!data.disable ? onClick : null}
        >
          <div className="d-flex justify-content-center align-content-center align-items-center">
            <div className={"btn__name"}>{data.btnName}</div>
          </div>
        </button>
      )}
      {data.isLoading && (
        <button
          className={`btn-wrapper loading ${data.buttonType} ${data.disable} ${
            data.buttonSize === "md-x"
              ? data.buttonSize + "pb-4"
              : data.buttonSize
          }`}
          type={data.type}
        />
      )}
    </>
  );
  return (
    <React.Fragment>
      <>{inputElement}</>
    </React.Fragment>
  );
};
Index.propTypes = {
  buttonType: PropTypes.string.isRequired,
  buttonSize: PropTypes.string.isRequired,
};
Index.defaultProps = {
  buttonType: "primary",
  buttonSize: "sm",
};
export default Index;
